/**
 * R-264 / 5e-2 (/simplify) — the "standing hard balance failure" predicate.
 *
 * A hard (`overrideBehavior === "block"`) balance failure that has NOT been
 * overridden is what pins a batch out of balance — soft failures and overridden
 * ones don't. This one-liner invariant was hand-rolled at five sites
 * (reconcileBatch's advisory-park auto-clear and releaseBatch in
 * workflow-engine, the clear-balance-review route, and both balance panels).
 *
 * It is generic over the four failure shapes — rule-runtime's `BalanceFailure`,
 * the route's inline `{ overrideBehavior?, overridden? }`, and the two web DTOs
 * (`BalanceFailureDto` / `BalanceFailureEntry`) — because all four carry
 * `overrideBehavior` plus an optional `overridden`. Consolidating the predicate
 * (not the types) keeps the invariant in one place without forcing a type merge
 * across the api/web/package boundary.
 */
export function standingHardBalanceFailures(failures) {
    return failures.filter((f) => f.overrideBehavior === "block" && !f.overridden);
}
/**
 * R-274 7d (/simplify) — convenience predicate for Prisma JsonValue callers.
 *
 * Both export-flush.ts (releaseExportGroup) and the export-groups GET route
 * need to ask "does this batch's balanceFailures JsonValue contain a standing
 * hard failure?" with the same Array.isArray cast. This one-liner keeps that
 * cast in one place.
 */
export function batchHasStandingHardBalance(raw) {
    if (!Array.isArray(raw))
        return false;
    const failures = raw;
    return standingHardBalanceFailures(failures).length > 0;
}
//# sourceMappingURL=balance-failures.js.map